import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getUserQuestsHistory } from 'services/questsService'
//types
import { UserQuestsHistoryResponse } from 'types'
//utils
import { handleError } from 'utils/utils'

const useQueryGetUserQuestsHistory = (paginationParams: Record<string, string>) => {
  const { data, isFetching, refetch } = useQuery<AxiosResponse<UserQuestsHistoryResponse, Error>>(
    QueryKeys.USER_QUESTS_HISTORY,
    () => getUserQuestsHistory(paginationParams),
    {
      onError: handleError,
      refetchOnWindowFocus: false,
    }
  )

  return { questsHistory: data?.data, isLoadingQuestsHistory: isFetching, refetchHistory: refetch }
}

export default useQueryGetUserQuestsHistory
